import React, { useRef } from "react";
import { DEFAULT_DATE_FORMAT } from "../utils/constants";
import ClassNames from "classnames";
import { Input } from '../../field';
import CalendarPickerContext from "../context/CalendarPickerContext";
import { onDatepickerInputChange } from "../utils/dateUtils";
import { getKeyTable } from "../utils/NavUtils";
var DatepickerInput = function DatepickerInput(props) {
  var required = props.required,
    readonly = props.readonly,
    disabled = props.disabled,
    fieldTitle = props.fieldTitle,
    placeholder = props.placeholder,
    style = props.style,
    _props$editable = props.editable,
    editable = _props$editable === void 0 ? true : _props$editable,
    selectRange = props.selectRange,
    mode = props.mode,
    rangeConnecterFormat = props.rangeConnecterFormat,
    _props$dateSeparator = props.dateSeparator,
    dateSeparator = _props$dateSeparator === void 0 ? '/' : _props$dateSeparator,
    _props$fieldWidth = props.fieldWidth,
    fieldWidth = _props$fieldWidth === void 0 ? 320 : _props$fieldWidth,
    name = props.name,
    id = props.id,
    suffixTemplate = props.suffixTemplate;
  var triggerButtonRef = useRef(null);
  var _React$useContext = React.useContext(CalendarPickerContext),
    openStatusStore = _React$useContext.openStatusStore,
    openStatusDispatch = _React$useContext.openStatusDispatch,
    inputValueStore = _React$useContext.inputValueStore,
    inputValueDispatch = _React$useContext.inputValueDispatch,
    setHasInputError = _React$useContext.setHasInputError,
    hasInputError = _React$useContext.hasInputError,
    valueDispatch = _React$useContext.valueDispatch,
    activeStartDateDispatch = _React$useContext.activeStartDateDispatch,
    setInputRefList = _React$useContext.setInputRefList,
    inputRefList = _React$useContext.inputRefList,
    uuid = _React$useContext.uuid,
    hideTitleOnInput = _React$useContext.hideTitleOnInput,
    format = _React$useContext.format,
    editForbidden = _React$useContext.editForbidden,
    value = _React$useContext.value,
    useCustomValidation = _React$useContext.useCustomValidation,
    error = _React$useContext.error,
    customErrorNode = _React$useContext.customErrorNode,
    dateCalculator = _React$useContext.dateCalculator;
  var isOpen = openStatusStore.isOpen;
  var errorContent = null;
  if (!customErrorNode) {
    errorContent = /*#__PURE__*/React.createElement("div", {
      id: "errormessage",
      "aria-live": "polite",
      className: "ap-field-email-validation-error"
    }, "Please enter a valid date");
  } else {
    if (typeof customErrorNode === 'string') {
      errorContent = /*#__PURE__*/React.createElement("div", {
        id: "errormessage",
        "aria-live": "polite",
        className: "ap-field-email-validation-error"
      }, customErrorNode);
    } else {
      errorContent = customErrorNode;
    }
  }
  var handleClickTriggerButton = function handleClickTriggerButton(isKeyboard) {
    if (isKeyboard === void 0) {
      isKeyboard = false;
    }
    if (props.onClickCalendarIcon) {
      props.onClickCalendarIcon();
    }
    if (isOpen) {
      openStatusDispatch({
        type: "closeWithValidation",
        payload: {
          inputValue: inputValueStore.inputValue,
          setHasInputError: setHasInputError,
          selectRange: selectRange,
          isKeyboard: isKeyboard,
          editForbidden: editForbidden,
          panelValue: value
        }
      });
    } else {
      openStatusDispatch({
        type: "openWithValidation",
        payload: {
          inputValue: inputValueStore.inputValue,
          setHasInputError: setHasInputError,
          selectRange: selectRange,
          isKeyboard: isKeyboard,
          editForbidden: editForbidden,
          panelValue: value
        }
      });
    }
    if (!isKeyboard) {
      inputRefList[2].current.classList.remove('keyboard-focus');
    }
  };
  var handleToggleKeyDown = function handleToggleKeyDown(e) {
    var _getKeyTable = getKeyTable(e),
      isEnter = _getKeyTable.isEnter,
      isDown = _getKeyTable.isDown;
    if (isEnter || isDown) {
      handleClickTriggerButton(true);
    }
  };
  var inputClasses = ClassNames("a-date-picker-header", {
    open: isOpen
  }, {
    noError: !hasInputError
  });
  var triggerButton = /*#__PURE__*/React.createElement("span", {
    role: "button",
    tabIndex: disabled || readonly || isOpen ? -1 : 0,
    "aria-disabled": disabled,
    "aria-label": "Choose date",
    className: ClassNames("Appkit4-icon icon-calendar-outline ap-field-icon-btn", {
      "readonly": readonly
    }),
    "aria-haspopup": "dialog",
    onClick: function onClick() {
      return handleClickTriggerButton(false);
    },
    onKeyDown: handleToggleKeyDown,
    "aria-controls": "ap-datepicker-" + uuid,
    ref: triggerButtonRef
  });
  var onValueChange = function onValueChange(inputValue, e) {
    e.stopPropagation();
    var currentValue = onDatepickerInputChange(e, selectRange, rangeConnecterFormat, dateSeparator, format);
    inputValueDispatch({
      type: "setInputValueByString",
      payload: {
        value: currentValue
      }
    });
    if (currentValue === '') {
      valueDispatch({
        type: "setValue",
        payload: {
          value: undefined
        }
      });
      activeStartDateDispatch({
        type: "init"
      });
    }
    openStatusDispatch({
      type: 'close',
      payload: {
        isKeyboard: false
      }
    });
  };
  var getMaskValue = function getMaskValue() {
    var maskInputValue = "";
    if ((mode === 'showRangePanel' || mode === 'showDoubleCalendarWithRangePanel') && !selectRange) {
      var _inputValueStore$inpu;
      maskInputValue = (_inputValueStore$inpu = inputValueStore.inputValue) === null || _inputValueStore$inpu === void 0 ? void 0 : _inputValueStore$inpu.substring(0, format.length);
    } else {
      maskInputValue = inputValueStore.inputValue;
    }
    return maskInputValue;
  };
  var dpDate = dateCalculator.calculateDateValuesFromDateString(getMaskValue());
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: inputClasses
  }, /*#__PURE__*/React.createElement(Input, {
    id: id,
    hideTitleOnInput: hideTitleOnInput,
    type: "text",
    required: required,
    readonly: readonly || editForbidden,
    disabled: disabled,
    errorNode: errorContent,
    error: useCustomValidation ? error : hasInputError,
    title: fieldTitle,
    suffix: triggerButton,
    value: getMaskValue(),
    onChange: onValueChange,
    isOpen: isOpen,
    dpShowPlaceholder: isOpen,
    dpEditable: editable,
    placeholder: placeholder || DEFAULT_DATE_FORMAT.toLowerCase(),
    textReadonly: !editable,
    tabIndex: disabled || readonly || isOpen ? -1 : 0,
    onRef: function onRef(ref) {
      return setInputRefList(ref);
    },
    style: {
      width: fieldWidth
    },
    name: name,
    dpSuffixTemplate: suffixTemplate,
    dpDate: dpDate
  }));
};
export default DatepickerInput;